import { render } from "./global-tast-box.vue?vue&type=template&id=77e738f1"
import script from "./global-tast-box.vue?vue&type=script&lang=js"
export * from "./global-tast-box.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__